module.exports = (theme) => ({
  ".csf": { "@apply ds-flex ds-flex-col": 1 },
  ".csf-step-heading": { "@apply ds-text-2xl ds-font-bold ds-leading-base sm:!ds-text-4xl sm:!ds-leading-xl": 1 },

  ".csf-step": {
    "@apply ds-pt-xl ds-pb-2xl sm:!ds-py-2xl md:!ds-py-2xl": 1,
    "@apply ds-flex ds-flex-col ds-gap-y-2xl md:!ds-gap-y-3xl": 1,
  },

  /** Customer Service Funnel step 1: categories (filter 1) */
  ".csf-1": { "@apply ds-csf-step": 1 },
  ".csf-1-toc": {
    "@apply ds-grid ds-gap-xl": 1,
    gridTemplateColumns: "repeat(auto-fit, minmax(154px, 1fr))",
    gridAutoRows: "minmax(130px, 1fr)",
    [`@media screen and (min-width: ${theme("screens.md")})`]: {
      gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
      gridAutoRows: "minmax(180px, 1fr)",
    },
    [`@media screen and (min-width: ${theme("screens.lg")})`]: {
      gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
      gridAutoRows: "minmax(200px, 1fr)",
    },
  },
  ".csf-1-toc-item": {
    "@apply ds-flex ds-flex-col ds-items-center ds-justify-center ds-gap-y-sm ds-h-full": 1,
    "@apply ds-border ds-border-tertiary-lightergrey": 1,
    "@apply ds-p-sm md:!ds-py-xl md:!ds-px md:!ds-gap-y lg:!ds-p-xl": 1,
    "&:hover, &:focus": {
      "@apply ds-bg-primary-yellow": 1,
      "& .csf-1-toc-item-icon": {
        "@apply ds-transition ds-ease-in-out ds-transition-all ds-scale-105": 1,
      },
    },
    "&:active": { "@apply ds-bg-primary-yellow ds-brightness-90": 1 },
    "&.selected": { "@apply ds-bg-primary-yellow": 1 },
    ".csf-1-toc-item-icon": {
      "@apply ds-inline-block ds-bg-center ds-bg-no-repeat ds-bg-cover ds-shrink-0 ds-scale-100": 1,
      "@apply ds-w-[45px] ds-h-[45px] md:!ds-w-[50px] md:!ds-h-[50px] lg:!ds-w-[71px] lg:!ds-h-[71px]": 1,
    },
    ".csf-1-toc-item-text": {
      overflowWrap: "anywhere",
      "@apply ds-text-center ds-grow": 1,
      "@apply ds-text-xl ds-leading-base sm:!ds-text-3xl sm:!ds-leading-xl ds-text-primary-black": 1,
    },
  },

  /** Customer Service Funnel step 2: subcategories (filter 2) */
  ".csf-2": { "@apply ds-csf-step": 1 },
  ".csf-2-toc": {
    "@apply ds-flex ds-flex-col ds-gap-y sm:!ds-flex-row sm:!ds-flex-wrap sm:!ds-gap-xl": 1,
    "& > li": { "@apply ds-grow ds-text-center": 1 },
    "& > li:nth-last-child(-n+3)": {
      "@apply sm:!ds-min-w-max sm:!ds-max-w-[33%]": 1,
    },
  },
  ".csf-2-toc-item": {
    "@apply ds-block ds-py ds-px-xl md:!ds-px-2xl lg:!ds-px-3xl ds-text-xl ds-leading-base sm:!ds-text-3xl ds-leading-xl": 1,
    "@apply ds-text-primary-black ds-bg-background-blue": 1,
    "&:hover, &:focus": {
      "@apply ds-text-primary-white ds-bg-secondary-darkblue": 1,
    },
    "&:active": { "@apply ds-text-primary-white ds-bg-primary-black": 1 },
    "&.selected": {
      "@apply ds-text-primary-white ds-bg-secondary-darkblue": 1,
    },
  },

  /** Customer Service Funnel step 3: solutions and contacts */
  ".csf-3": { "@apply ds-csf-step": 1 },
  ".csf-3-solutions": { "@apply ds-grid ds-grid-flow-row ds-gap-xl md:!ds-grid-flow-col md:!ds-grid-cols-2 lg:!ds-gap-2xl": 1 },
  ".csf-3-solutions + .csf-3-contacts": { "@apply ds-pt-2xl md:!ds-pt-3xl": 1 },

  /** Solutions */
  ".csf-3-solution-padding": { "@apply ds-pt-xl ds-px-xl ds-pb-2xl lg:!ds-p-2xl": 1 },
  ".csf-3-solution": {
    "@apply ds-h-full": 1,
    "@apply ds-csf-3-solution-padding": 1,
    "&-content": {
      "@apply ds-flex ds-flex-col ds-gap-y-xl ds-h-full": 1,
      "&-heading": { "@apply ds-text-3xl ds-leading-xl ds-font-regular": 1 },
      "&-text": { "@apply ds-base-editor-text ds-text-base ds-leading-base ds-flex-grow": 1 },
      ".button": { "@apply ds-self-center md:!ds-self-start !ds-m-0": 1 },
    },
  },

  /** Styles for detached solutions (for TinyMCE and OPE modes) */
  ".csf-3-solution-detached": { "@apply ds-max-w-[641px] ds-mx-auto": 1 },

  /** Styles for edition solution in OPE */
  ".csf-3-solution:not(.csf-3-solutions .csf-3-solution)": {
    "@apply ds-csf-3-solution-detached ds-csf-3-solution-padding": 1,
  },

  /** Styles for editing solution's text containers in TinyMCE */
  ".csf-3-solution-editor": {
    "@apply ds-base-editor-text ds-text-base ds-leading-base": 1,
    "@apply ds-csf-3-solution-detached ds-csf-3-solution-padding": 1,
  },

  /** Solution themes */
  ".csf-3-solution-dark": {
    "@apply ds-bg-secondary-darkblue": 1,
    ".csf-3-solution-content :not(.button)": { "@apply ds-text-primary-white": 1 },
  },
  ".csf-3-solution-medium": { "@apply ds-bg-background-blue": 1 },
  ".csf-3-solution-light": { "@apply ds-border ds-border-tertiary-lightergrey": 1 },

  ".csf-3-contacts": {
    "@apply ds-grid ds-grid-cols-1 ds-gap-xl sm:!ds-auto-rows-fr sm:!ds-grid-cols-2 lg:!ds-grid-cols-3 lg:!ds-gap-2xl": 1,
  },

  /** Contacts */
  ".csf-3-contact-padding": {
    "@apply ds-px-xl ds-pb-2xl lg:!ds-px-xl lg:!ds-pb-2xl": 1,
  },
  ".csf-3-contact": {
    "@apply ds-relative ds-flex ds-flex-col ds-gap-y-xl ds-h-full": 1,
    "@apply ds-csf-3-contact-padding": 1,
    "& > *": { "@apply ds-relative": 1 },
    "&::before": {
      "@apply ds-content-[''] ds-absolute ds-inset-0": 1,
      "@apply ds-top-[60px] md:!ds-top-[82px]": 1,
      "@apply ds-bg-background-blue": 1,
    },
    ".csf-3-contact-icon": {
      "@apply ds-shrink-0 ds-bg-background-white ds-rounded-full ds-flex ds-self-center": 1,
      "@apply ds-w-[110px] ds-h-[110px] md:!ds-w-[150px] md:!ds-h-[150px]": 1,
      "& > :first-child": {
        "@apply ds-m-auto ds-bg-center ds-bg-no-repeat ds-bg-cover": 1,
        "@apply ds-w-[65px] ds-h-[65px] md:!ds-w-[85px] md:!ds-h-[85px]": 1,
      },
    },
    ".csf-3-contact-content": {
      "@apply ds-flex ds-flex-col ds-w-full ds-h-full ds-box-content ds-h-full": 1,
      "&-heading": {
        "@apply ds-text-2xl ds-leading-base sm:!ds-text-4xl sm:!ds-leading-xl ds-pb-xl": 1,
        overflowWrap: "anywhere",
      },
      "&-text": { "@apply ds-base-editor-text ds-grow": 1 },
      "&-text:not(:last-child)": { "@apply ds-pb-xl sm:!ds-pb": 1 },
      ".button": { "@apply ds-self-center md:!ds-self-start !ds-m-0 ds-min-w-0": 1 },
    },
  },

  /** Styles for detached contacts (for TinyMCE and OPE modes) */
  ".csf-3-contact-detached": { "@apply ds-max-w-[413px] ds-mx-auto": 1 },

  /** Styles for edition solution in OPE */
  ".csf-3-contact:not(.csf-3-contacts .csf-3-contact)": {
    "@apply ds-csf-3-contact-detached ds-csf-3-contact-padding ds-pt-xl": 1,
  },

  /** Styles for editing contact's text containers in TinyMCE */
  ".csf-3-contact-editor": {
    "@apply ds-base-editor-text": 1,
    "@apply ds-csf-3-contact-detached ds-csf-3-contact-padding ds-pt-xl": 1,
  },
});
